import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { ApiGetProvider } from '../api-get/api-get';
import { Observable, BehaviorSubject } from 'rxjs';
import { MessagesStoreProvider } from '../messages-store/messages-store';
import { TasksStoreProvider } from '../tasks-store/tasks-store';
import { AttachmentsStoreProvider } from '../attachments-store/attachments-store';
import { AdvalvasItemStoreProvider } from '../advalvas-item-store/advalvas-item-store';
import { LocationStoreProvider } from '../location-store/location-store';
import { RoomsStoreProvider } from '../rooms-store/rooms-store';
import { CategoriesStoreProvider } from '../categories-store/categories-store';
import { UsersStoreProvider } from '../users-store/users-store';
import { map } from 'rxjs/operators/map';
import { ConnectionProvider } from '../connection/connection';
import { CalendarItemsStoreProvider } from '../calendar-items-store/calendar-items-store';
import { DatabaseProvider } from '../database/database';
import { ApiPostProvider } from '../api-post/api-post';
import { ConfigDataProvider } from '../config-data/config-data';

@Injectable()
export class SyncProvider {

	private db = new DatabaseProvider();

	public syncTasksObservable$: BehaviorSubject<any> = new BehaviorSubject(false);

	constructor(
		private apiProvider: ApiProvider,
		private apiGetProvider: ApiGetProvider,
		private apiPostProvider: ApiPostProvider,
		private messagesStore: MessagesStoreProvider,
		private tasksStore: TasksStoreProvider,
		private attachmentsStore: AttachmentsStoreProvider,
		private advalvasItemStore: AdvalvasItemStoreProvider,
		private locationStore: LocationStoreProvider,
		private roomsStore: RoomsStoreProvider,
		private connectionPrvdr: ConnectionProvider,
		private categoriesStore: CategoriesStoreProvider,
		private usersStore: UsersStoreProvider,
		private calendarItemStore: CalendarItemsStoreProvider,
		private configDataPrvdr: ConfigDataProvider
	) {
	}


	sync(): Observable<any> {

		let connectionType = this.connectionPrvdr.getConnectionType();

		let getMessageObservable: Observable<any> = this.apiGetProvider.getMessages(connectionType);
		getMessageObservable = this.apiProvider.pipeErrorToaster(getMessageObservable);

		getMessageObservable = getMessageObservable.pipe(map((data) => {

			if (data && data.status == "success") {

				let messages = data.messages && data.messages.length > 0 ? data.messages : [];
				let attachments = data.attachments && data.attachments.length > 0 ? data.attachments : [];
				let tasks = data.werkbonnen && data.werkbonnen.length > 0 ? data.werkbonnen : [];

				let messagePro = this.messagesStore.addBatch(messages);
				let attachmentsPro = this.attachmentsStore.addBatch(attachments);
				let tasksPro = this.tasksStore.addBatch(tasks);


				Promise.all(([messagePro, attachmentsPro, tasksPro])).then(() => {
					return true;
				}).catch(() => { return true; });

			}

		}));

		let getAdvalvasObservable: Observable<any> = this.apiGetProvider.getAdvalvasItems();
		getAdvalvasObservable = this.apiProvider.pipeErrorToaster(getAdvalvasObservable);

		getAdvalvasObservable = getAdvalvasObservable.pipe(map((data) => {

			if (data && data.status == "success") {
				let list = data.data;
				this.advalvasItemStore.addBatch(list).then(() => {
					return true;
				}).catch(() => { return true; })
			}

		}))


		let getUsersObservable: Observable<any> = this.apiGetProvider.getUsers();
		getUsersObservable = this.apiProvider.pipeErrorToaster(getUsersObservable);

		getUsersObservable = getUsersObservable.pipe(map((data) => {

			if (data && data.status == "success") {
				this.usersStore.addBatch(data.data.allusers).then(() => {
					return true;
				}).catch(() => { return true })
			}

		}));


		let getAllMyUsersObservable: Observable<any> = this.apiGetProvider.getAllMyUsers();
		getAllMyUsersObservable = this.apiProvider.pipeErrorToaster(getAllMyUsersObservable);

		getAllMyUsersObservable = getAllMyUsersObservable.pipe(map((data) => {

			if (data && data.status == "success") {
				this.usersStore.addBatchAllUsers(data.data).then(() => {
					return true;
				}).catch(() => { return true; })
			}

		}));


		let getPermissionsObservable: Observable<any> = this.apiGetProvider.getPermissions();
		getPermissionsObservable = this.apiProvider.pipeErrorToaster(getPermissionsObservable);

		getPermissionsObservable = getPermissionsObservable.pipe(map((data) => {

			if (data && data.status == 'success') {
				if (data.data && data.data.length > 0)
					this.configDataPrvdr.storePermissions(data.data);
			}

			return true;

		}));


		return Observable.forkJoin([getMessageObservable, getAdvalvasObservable, getUsersObservable, getAllMyUsersObservable, getPermissionsObservable]);

	}

	syncBackground() {

		let messageTemplatesObservable: Observable<any> = this.apiGetProvider.getMessageTemplates();
		messageTemplatesObservable = this.apiProvider.pipeErrorToaster(messageTemplatesObservable);

		messageTemplatesObservable = messageTemplatesObservable.pipe(map((data) => {

			if (data && data.status == "success") {

				this.messagesStore.addToMessageTempale(data.data).then(() => {
					return true;
				}).catch(() => { return true })
			}

		}));

		let werkbontypesObservable: Observable<any> = this.apiGetProvider.getWerkbontypes();
		werkbontypesObservable = this.apiProvider.pipeErrorToaster(werkbontypesObservable);

		werkbontypesObservable = werkbontypesObservable.pipe(map((data) => {

			if (data && data.status == "success") {

				this.tasksStore.addToTaskTypes(data.data).then(() => {
					return true;
				}).catch(() => { return true })
			}

		}));


		let locationObservable: Observable<any> = this.apiGetProvider.getAfdelingen();
		locationObservable = this.apiProvider.pipeErrorToaster(locationObservable);

		locationObservable = locationObservable.pipe(map((data) => {

			if (data && data.status == "success") {
				this.locationStore.addBatch(data.data).then(() => {
					return true;
				}).catch(() => { return true })
			}

		}));

		let categoriesObservable: Observable<any> = this.apiGetProvider.getCategories();
		categoriesObservable = this.apiProvider.pipeErrorToaster(categoriesObservable);

		categoriesObservable = categoriesObservable.pipe(map((data) => {

			if (data && data.status == "success") {

				this.categoriesStore.addBatch(data.data).then(() => {
					return true;
				}).catch(() => { return true });
			}

		}));

		let roomsObservable: Observable<any> = this.apiGetProvider.getRooms();
		roomsObservable = this.apiProvider.pipeErrorToaster(roomsObservable);

		roomsObservable = roomsObservable.pipe(map((data) => {

			if (data && data.status == "success") {

				this.roomsStore.addBatch(data.data).then(() => {
					return true;
				}).catch(() => { return true })
			}

		}));

		let calendarsObservable: Observable<any> = this.apiGetProvider.getCalendarObjects();
		calendarsObservable = this.apiProvider.pipeErrorToaster(calendarsObservable);

		calendarsObservable = calendarsObservable.pipe(map((data) => {

			if (data && data.status == "success") {

				this.calendarItemStore.addToCalendarItems(data.calendaritems).then(() => {

					this.calendarItemStore.addToCalendars(data.calendars).then(() => {
						return true;
					}).catch(() => { return true })

				}).catch(() => { return true });
			}

		}))


		return Observable.forkJoin([messageTemplatesObservable, werkbontypesObservable, locationObservable, categoriesObservable, roomsObservable, calendarsObservable])


	}

	syncCritical() {

		let connectionType = this.connectionPrvdr.getConnectionType();

		let getMessageObservable: Observable<any> = this.apiGetProvider.getMessages(connectionType);

		getMessageObservable = getMessageObservable.pipe(map((data) => {

			if (data && data.status == "success") {

				let messages = data.messages && data.messages.length > 0 ? data.messages : [];
				let attachments = data.attachments && data.attachments.length > 0 ? data.attachments : [];
				let tasks = data.werkbonnen && data.werkbonnen.length > 0 ? data.werkbonnen : [];

				let messagePro = this.messagesStore.addBatch(messages);
				let attachmentsPro = this.attachmentsStore.addBatch(attachments);
				let tasksPro = this.tasksStore.addBatch(tasks);


				Promise.all(([messagePro, attachmentsPro, tasksPro])).then(() => {
					this.messagesStore.loadList().then(() => { }).catch(() => { });
					this.tasksStore.loadTasksList().then(() => { }).catch(() => { });
					return true;
				}).catch(() => { return true; });

			}

		}));

		let calendarsObservable: Observable<any> = this.apiGetProvider.getCalendarObjects();

		calendarsObservable = calendarsObservable.pipe(map((data) => {

			if (data && data.status == "success") {

				this.calendarItemStore.addToCalendarItems(data.calendaritems).then(() => {

					this.calendarItemStore.addToCalendars(data.calendars).then(() => {
						return true;
					}).catch(() => { return true })

				}).catch(() => { return true });
			}

		}))

		return Observable.forkJoin([getMessageObservable, calendarsObservable]);;

	}

	syncMessages() {

		this.db.messages.where("appstatus").equals("NEW").or('appstatus').equals("READ").or("appstatus").equals("DELETED").or("appstatus").equals("UPDATED").sortBy("datecreated").then((data) => {

			if (data && data.length > 0) {

				let messagesObject = {
					messages: data,
					mobile_key: this.configDataPrvdr.getMobileKey()
				}

				let syncMessageObservable: Observable<any> = this.apiPostProvider.saveMessages(messagesObject);

				syncMessageObservable.subscribe((res) => {

					if (res && res.status == "success") {
						data.forEach((temp) => {

							/** 
							 *  Update local database @Messages status after sync into server
							 */
							if (temp.appstatus != "DELETED") {
								temp.appstatus = "";
								this.messagesStore.updateMessage(temp.id, temp).then(() => {
									console.log('message updated in local DB..!');
								}).catch((e) => {
									console.error("There is some error in update message records in local DB ", e);
								})
							} else if (temp.appstatus == "DELETED") {
								this.messagesStore.deleteMessage(temp.id).then(() => {
									console.log('message deleted in local DB..!');
								}).catch((e) => {
									console.error("There is some error in delete message records in local DB ", e);
								})
							}

						})

						/* Load updated messages list.....*/

						this.messagesStore.loadList().then(() => { }).catch(() => { });

						this.messagesStore.showSyncMessagesError$.next(false);

					}

				}, (e) => {
					console.log(e);
				});
			}

		}).catch((e) => {
			console.log(e);
		});

	}

	syncTasks() {

		this.db.tasks.where("appstatus").equals("NEW").or("appstatus").equals("MARKED").sortBy("datecreated").then((data) => {

			if (data && data.length > 0) {

				let tasksObject = {
					messages: data,
					mobile_key: this.configDataPrvdr.getMobileKey()
				}

				let syncTaskObservable: Observable<any> = this.apiPostProvider.saveTasks(tasksObject);

				syncTaskObservable.subscribe((res) => {

					if (res && res.status == "success") {
						data.forEach((temp) => {
							temp.appstatus = "";

							/** 
							 *  Update local database @Tasks status after sync into server
							 */

							this.tasksStore.updateTask(temp.id, temp).then(() => {
								console.log('Tasks updated in local DB..!');
							}).catch((e) => {
								console.error("There is some error in update tasks records in local DB ", e);
							})

						})

						/* Load updated tasks list.....*/

						this.syncCritical().subscribe(() => { }, () => { })

						this.tasksStore.loadTasksList().then(() => { }).catch(() => { });
						this.tasksStore.showSyncTasksError$.next(false);

					}

				}, (e) => {
					console.log(e);
				});
			}

		}).catch((e) => {
			console.log(e);
		});

	}

	syncEvents() {

		this.db.calendarItems.where("appstatus").equals("NEW").or("appstatus").equals("UPDATED").toArray().then((data) => {

			if (data && data.length > 0) {

				let eventsObject = {
					events: data,
					mobile_key: this.configDataPrvdr.getMobileKey()
				}

				let syncEventsaObservable: Observable<any> = this.apiPostProvider.saveEvents(eventsObject);

				syncEventsaObservable.subscribe((res) => {

					if (res && res.status == "success") {

						/** 
						 *  Update local database @Events status after sync into server
						 */
						data.forEach((temp) => {

							temp.appstatus = "";

							this.calendarItemStore.editCalendarEvent(temp.id, temp).then(() => {
								console.log("Events are updated in local DB");
							}).catch((e) => {
								console.error("There is some error in updated events records in local DB.");
							});
						});

						/* Load updated Events list.....*/

						this.calendarItemStore.loadCalendarItemsList().then(() => { }).catch(() => { });
						this.calendarItemStore.syncEventError$.next(false);

					}

				}, (e) => { console.log(e) });

			}

		}).catch((e) => {
			console.log(e);
		});

	}


	syncMessagesWithAttchments() {


		return new Promise((resolve, reject) => {

			this.db.messages.where("appstatus").equals("NEW").or("appstatus").equals("DELETED").or("appstatus").equals("UPDATED").sortBy("datecreated").then((data) => {

				if (data && data.length > 0) {

					let messagesObject = {
						messages: data,
						mobile_key: this.configDataPrvdr.getMobileKey()
					}

					let syncMessageObservable: Observable<any> = this.apiPostProvider.saveMessages(messagesObject);

					syncMessageObservable.subscribe((res) => {

						if (res && res.status == "success") {

							resolve(res);

							data.forEach((temp) => {

								/** 
								 *  Update local database @Messages status after sync into server
								 */
								if (temp.appstatus != "DELETED") {
									temp.appstatus = "";
									this.messagesStore.updateMessage(temp.id, temp).then(() => {
										console.log('message updated in local DB..!');
										resolve(data);
									}).catch((e) => {
										reject(e);
										console.error("There is some error in update message records in local DB ", e);
									})
								} else if (temp.appstatus == "DELETED") {
									this.messagesStore.deleteMessage(temp.id).then(() => {
										console.log('message deleted in local DB..!');
									}).catch((e) => {
										console.error("There is some error in delete message records in local DB ", e);
									})
								}

							})

							/* Load updated messages list.....*/

							this.messagesStore.loadList().then(() => { }).catch(() => { });

							this.messagesStore.showSyncMessagesError$.next(false);

						} else {
							reject(res);
						}

					}, (e) => {
						console.log(e);
						reject(e);
					});
				} else {
					reject("No data found in local database");
				}

			}).catch((e) => {
				console.log(e);
				reject(e);
			});

		})

	}


	syncTasksWithAttachments() {

		return new Promise((resolve, reject) => {

			this.db.tasks.where("appstatus").equals("NEW").or("appstatus").equals("MARKED").sortBy("datecreated").then((data) => {

				if (data && data.length > 0) {

					let tasksObject = {
						messages: data,
						mobile_key: this.configDataPrvdr.getMobileKey()
					}

					let syncTaskObservable: Observable<any> = this.apiPostProvider.saveTasks(tasksObject);

					syncTaskObservable.subscribe((res) => {

						if (res && res.status == "success") {
							data.forEach((temp) => {
								temp.appstatus = "";

								/** 
								 *  Update local database @Tasks status after sync into server
								 */

								resolve(res);

								this.tasksStore.updateTask(temp.id, temp).then(() => {
									console.log('Tasks updated in local DB..!');
									resolve(true);
								}).catch((e) => {
									console.error("There is some error in update tasks records in local DB ", e);
									reject(e);
								})

							});

							this.tasksStore.loadTasksList().then(() => { }).catch(() => { });
							this.tasksStore.showSyncTasksError$.next(false);

						}

					}, (e) => {
						console.log(e);
						reject(e);
					});
				}

			}).catch((e) => {
				console.log(e);
				resolve(e);
			});


		});

	}



}



// WEBPACK FOOTER //
// ./src/providers/sync/sync.ts